const USER_META = 'userMeta';
export default USER_META;

export enum CookieKeys {
  JWT = 'jwt',
  FTP_USER_ID = 'ftpUserId',
  WEBSITE_ID = 'websiteId',
  USERNAME = 'username',
  PATH = '/',
  SAME_SITE = 'Lax'
}
